import { faGithub, faInstagram, faLinkedinIn, faSpotify, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CenteredContainer, IconContainer, IconWrapper } from "./StyledComponents"

const Footer: React.FC = () => {

    return (
        <footer>
            <IconContainer> 
                <IconWrapper altColor="#0072B1" onClick={() => window.open("https://www.linkedin.com/in/samjirovec", "_empty")}>
                    <FontAwesomeIcon icon={faLinkedinIn} color="white" size="lg" /> 
                </IconWrapper>
                <IconWrapper altColor="gray" onClick={() => window.open("https://www.github.com/samjirovec", "_empty")}>
                    <FontAwesomeIcon icon={faGithub} color="white" size="lg" /> 
                </IconWrapper>
                <IconWrapper altColor="#1DB954" onClick={() => window.open("https://open.spotify.com/user/ultraflyingwhale?si=43f98fe1068f4c69", "_empty")}>
                    <FontAwesomeIcon icon={faSpotify} color="white" size="lg" />
                </IconWrapper>
                <IconWrapper altColor="#1DA1F2" onClick={() => window.open("https://twitter.com/TheJirocopter", "_empty")}>
                    <FontAwesomeIcon icon={faTwitter} color="white" size="lg" />
                </IconWrapper>
                <IconWrapper altColor="#E1306C" onClick={() => window.open("https://www.instagram.com/sam.jirovec/", "_empty")}>
                    <FontAwesomeIcon icon={faInstagram} color="white" size="lg" />
                </IconWrapper>
            </IconContainer>

           <CenteredContainer>
               <h6> Copyright &copy; Samuel Jirovec 2022 </h6>
           </CenteredContainer>
        </footer>
    )
}

export default Footer